import { AfterViewInit, Component, OnInit, ViewChild, OnDestroy, ElementRef, TemplateRef, ViewChildren, QueryList } from '@angular/core';
import { UserauthenticationserviceService } from '../services/userauthenticationservice.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { ProctoringService } from '../services/proctoring.service';
import { Util } from '../interceptors/util';
import { CbtserviceService } from '../services/cbtservice.service';
import { ExamService } from '../services/exam.service';
import { PassportData } from '../models/model';
import { of, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { CurrentUser } from '../models/CurrentUser';
import { LanguageService } from '../services/language.service';
import { CountdownComponent } from 'ngx-countdown';
import { CalculatorToggleService } from '../services/calculator-toggle.service';
import { environment } from 'src/environments/environment';
import { ExamInstructionToggleService } from '../services/exam-instruction-toggle.service';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { switchMap } from 'rxjs/operators';

declare var $: any

@Component({
  selector: 'app-exam-layout',
  templateUrl: './exam-layout.component.html',
  styleUrls: ['./exam-layout.component.css']
})
export class ExamLayoutComponent implements OnInit, AfterViewInit, OnDestroy {

  name: any = '';
  imageUrl: SafeUrl;
  thisurl = location.origin + '/';
  logourl: any;
  subdomain: any;
  loading: boolean = false;
  file: File;
  showlimittext: boolean;
  limittext: string;
  togglepassportui: boolean = false;
  uploadActionText: string = "Upload Passport";
  passportData: PassportData = {
    examno: ""
  };
  canUploadPassport: boolean;
  user: CurrentUser = new CurrentUser();
  webcammode: boolean = false;
  timeRemaining: number | null = null;
  timeLeftNotificationInterval: number[] = [];
  examTimeLeftSubscription: Subscription | null = null;
  examPausedSubscription: Subscription | null = null;
  examInstructionSubscription: Subscription | null = null;
  questionTimeLeftSubscription: Subscription | null = null;
  usecalc: boolean = false
  calcInterval: any;
  secondWebcamCheckInterval: any;
  sebQuitHeight = environment.isSeb ? "27px" : "0px";
  showInstructionLink: boolean = false;
  webcamModelRef: NgbModalRef;
  secondViewWebcamConnected = false;
  useQuestionTimer: boolean = false;
  isExamPaused = false;
  readonly EXAM_OPEN_DURATION = 12 * 60 * 60; // 12 hours


  @ViewChild('countdown') countdown: CountdownComponent;
  @ViewChild('countdownWrapper') countdownWrapper!: ElementRef;
  @ViewChild('passportCaptureModal') passportCaptureModal: TemplateRef<any>;

  constructor(public userauth: UserauthenticationserviceService,
    public toastr: ToastrService,
    public sanitizer: DomSanitizer,
    public util: Util,
    public proctorservice: ProctoringService,
    public examservice: ExamService,
    private cbtservice: CbtserviceService,
    private router: Router,
    private languageService: LanguageService,
    private calculatorToggleService: CalculatorToggleService,
    private examInstructionToggleService: ExamInstructionToggleService,
    private modalService: NgbModal) { }
  @ViewChildren('candidateVideo') candidateVideo: QueryList<ElementRef<HTMLVideoElement>>;
  @ViewChild('candidateSecondViewVideo') candidateSecondViewVideo: ElementRef<HTMLVideoElement>;
  @ViewChild('candidateSecondViewVideoDiv') candidateSecondViewVideoDiv: ElementRef<HTMLDivElement>;

  ngOnDestroy(): void {
    this.examTimeLeftSubscription?.unsubscribe();
    this.examPausedSubscription?.unsubscribe();
    this.examInstructionSubscription?.unsubscribe();
    this.questionTimeLeftSubscription?.unsubscribe();

    if (this.calcInterval) {
      clearInterval(this.calcInterval);
      this.calcInterval = null;
    }

    if (this.secondWebcamCheckInterval) {
      clearInterval(this.secondWebcamCheckInterval);
      this.secondWebcamCheckInterval = null;
    }
  }

  get language() {
    return this.languageService.language;
  }

  async ngAfterViewInit() {
    //  if (this.candidateVideo && !this.candidateVideo.nativeElement.srcObject) {
    // this.candidateVideo.nativeElement.srcObject =  await this.cbtservice.getVideoStream();
    //  }
    //  if (this.candidateVideoMobile && !this.candidateVideoMobile.nativeElement.srcObject) {
    //   this.candidateVideoMobile.nativeElement.srcObject =  await this.cbtservice.getVideoStream();
    //    }
    if (this.isInIframe()) {
      for (let video of this.candidateVideo) {
        video.nativeElement.srcObject = await this.cbtservice.getVideoStream();
      }

      const _hideSecondViewVideo = () => {
        this.candidateSecondViewVideo.nativeElement.srcObject = null;
        this.candidateSecondViewVideoDiv.nativeElement.style.display = 'none';
      };

      const _showSecondView = async () => {
        try {
          const dualViewPreference = await this.proctorservice.getDualViewPreference();
          if (dualViewPreference == 'webcam') {
            if (!this.candidateSecondViewVideo.nativeElement.srcObject) {
              const secondViewStream = await this.cbtservice.getSecondViewVideoStream();

              secondViewStream.getVideoTracks()[0].onended = () => {
                this.cbtservice.clearSecondViewMediaStreamPromise();
                _hideSecondViewVideo();
                setTimeout(_showSecondView, 10 * 1000);
              }

              this.candidateSecondViewVideo.nativeElement.srcObject = secondViewStream;
              this.candidateSecondViewVideoDiv.nativeElement.style.display = 'unset';
            }
          }
          else {
            _hideSecondViewVideo();
          }
        }
        catch (error) {
          console.error(error);
        }

        setTimeout(_showSecondView, 10 * 1000);
      };

      _showSecondView();

      // setInterval(async () => {
      //   const dualViewPreference = await this.proctorservice.getDualViewPreference();
      //   if(dualViewPreference == 'webcam'){

      //   }
      // })
    }
  }

  async ngOnInit() {
    //debugger;
    this.loading = true;
    try {
      await this.loadUser();
    }
    catch (e) {
      this.loading = false;
      throw e;
    }

    if (this.user) {
      this.name = this.user.fullname;
      //this.name = this.userauth.currentUser.fullname;
      //this.userauth.getuserprofileimage(user.username).toPromise().then(data => {
      //  const urlCreator = window.URL;

      //  var imageData = 'data:image/png;base64,' + data.imgdata;
      //  this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(imageData);
      //}).catch(err => this.toastr.error(err))

      // this.imageUrl = `${environment.CBTAPIURL}users/getimagebytes?examno=${this.user.username}&company=${this.user.company}`;
      await this.getUserImageUrl();
      this.examservice.CheckPassportCanUpload(this.user.username)
        .then(result => {
          this.canUploadPassport = result;
        })
        .catch(err => {
          if (err.error.Error) {
            this.toastr.error(err.error.Error);
          } else {
            this.toastr.warning(this.language.unableToConnectToServer);
          }
        })
    }
    else if (this.userauth.getCurrentUserToken()) {
      this.userauth.userLogout();
    }
    this.subdomain = this.util.getSubdomain();
    if (this.subdomain) {
      var data: any = await this.userauth.getsubdomaincompanyinfo(this.subdomain).toPromise().catch(err => { this.cbtservice.showHttpError(err); this.loading = false });
      this.logourl = data.logourl;
    }
    this.loading = false;

    this.questionTimeLeftSubscription = this.examservice.questionTimeLeft$
      .pipe(
        switchMap(timeLeft => {
          if (timeLeft !== null) {
            this.useQuestionTimer = true;
            this.timeLeftNotificationInterval = this.getNotifyIntervals(timeLeft);
            return of(timeLeft);
          } else {
            this.useQuestionTimer = false;
            return this.examservice.examTimeLeft$;
          }
        })
      )
      .subscribe(time => {
        this.timeRemaining = time;
        this.timeLeftNotificationInterval = this.getNotifyIntervals(time);
      })

    this.examPausedSubscription = this.examservice.examPaused$.subscribe(paused => {
      this.isExamPaused = paused;
      const countdown = this.countdown;
      if (countdown) {
        if (paused) {
          this.countdown.pause();
        } else {
          this.countdown.resume();
        }
      }
    });

    this.examInstructionSubscription = this.examservice.examInstruction$.subscribe(show => {
      this.showInstructionLink = show;
    });

    this.calcInterval = setInterval(() => {
      this.usecalc = this.util.usecalculator
    }, 1000);

    const _checkForSecondViewWebcam = () => {
      const secondViewDeviceId = this.cbtservice.getSecondViewDeviceId();
      this.secondViewWebcamConnected = !!secondViewDeviceId;
    }

    _checkForSecondViewWebcam();
    this.secondWebcamCheckInterval = setInterval(() => {
      //in case the user connects it afterwards
      _checkForSecondViewWebcam();
    }, 10000);

  }

  // get isOnSmallScreen(){
  //   return screen.height < 1080;
  // }

  private async getUserImageUrl() {
    this.imageUrl = this.user.imageversion <= 0 ? "/assets/images/defaultuserimage.jpeg" : await this.examservice.getcandidatepassporturl(this.user.company, this.user.username, this.user.imageversion, this.user.imagetype);
    //debugger
  }

  private async loadUser() {
    this.user = await this.userauth.getCurrentUser(true);
  }

  async raiseHandClicked() {
    await this.proctorservice.raiseHand(this.user.username);
    this.toastr.info(this.language.waitForProctorOk);
  }

  async checkcanuploadpassportstatus(): Promise<boolean> {
    //this.user = await this.userauth.getCurrentUser();
    var d: boolean = await this.examservice.CheckPassportCanUpload(this.user.username).catch(err => {
      if (err.error.Error) {
        this.toastr.error(err.error.Error);
      } else {
        this.toastr.warning(this.language.unableToConnectToServer);
      }
      return false;
    });
    if (d === false) {
      this.togglepassportui = false;
      this.limittext = this.language.passportChangeErr;
      this.showlimittext = true;
      setTimeout(() => { this.canUploadPassport = d }, 5000);
      return false;
    }
    else
      return true;
  }

  // async uploadPassport() {
  //   var canupload: boolean = await this.checkcanuploadpassportstatus();
  //   if (this.file != null && this.uploadActionText === "Save Passport" && canupload) {
  //     await this.uploadcandidateimagefile();
  //   }
  //   this.toggleUploadUI();
  // }

  async uploadcandidateimagefile() {
    this.passportData.examno = this.user.username;
    this.passportData.File = this.file;
    const formData = new FormData();
    formData.append("ExamNo", this.passportData.examno);
    formData.append("File", this.passportData.File);
    //check isface
    // const faceResult = await this.examservice.confirmPassportHasFace(this.file);
    // if (!faceResult.hasface) {
    //   this.toastr.error(`No Face was found in the Passport`);
    //   return;
    // }
    // if (faceResult.hasface  && faceResult.multipleFaces) {
    //   this.toastr.error(`Multiple Face was found in the Passport`);
    //   return;
    // }
    this.examservice.UploadPassport(formData)
      .then(async d => {
        this.toastr.success(this.language.uploadSuccessful);
        //self.location.reload();
        //this.user.imageversion++;//we can assume the image version has increased by 1
        //await this.getUserImageUrl();
        //we are doing thbis to force the component to reload, as passport upload may be what is required to allow the user to start his exam
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/exam/userexams'], { queryParams: { skipMediaTest: true } })
        });
        //window.location.reload();
      })
      .catch(err => {
        if (err.error.Error) {
          this.toastr.error(err.error.Error);
        } else {
          this.toastr.warning(err);
          console.log(err);
        }
      })
  }

  async imagefilereceived(file) {

    //$('#webcammodal').modal('hide');
    if (this.webcamModelRef) {
      this.webcamModelRef.close();
      this.webcamModelRef = null;
    }
    if (await this.checkcanuploadpassportstatus()) {
      this.file = file
      await this.uploadcandidateimagefile();
    }
  }

  onFileChange(evt): void {
    if (evt.target.files && evt.target.files[0]) {
      if (evt.target.files[0].size > 1000000) {
        this.limittext = this.language.maxFileUpload1mb;
        this.showlimittext = true;
        return;
      }
      this.file = evt.target.files[0];
      const reader = new FileReader();
      reader.onload = e => this.imageUrl = reader.result;
      reader.readAsDataURL(this.file);
    }
    this.showlimittext = false;
  }

  toggleUploadUI() {
    this.togglepassportui = !this.togglepassportui
    this.uploadActionText = this.togglepassportui ? this.language.savePassport : this.language.changePassport;
  }

  isProctorAssigned(): boolean {
    return this.proctorservice.proctorAssigned;
  }
  // examlist() {
  //   window.location.href = `${this.thisurl}exam/userexams`;

  // }

  // logout() {
  //   window.location.href = `${this.thisurl}logout`;+.
  async openLogoutConfirmModal(template: TemplateRef<any>) {
    const modalOptions: NgbModalOptions = {
      backdrop: 'static',      
      keyboard: false,          
      centered: true,
      size: 'lg',
      ariaLabelledBy: 'logoutConfirmModalTitle'
    };
    this.webcamModelRef?.close();
    
   this.modalService.open(template, modalOptions);
  }
  async showwebcammodal() {
    this.webcammode = true
    //$('#webcammodal').modal('show');

    const modalOptions: NgbModalOptions = {
      backdrop: true,
      keyboard: true,
      centered: true,
      // ariaLabelledBy: 'modalTitleId' + this.examId,
      // ariaDescribedBy: 'modalDescId' + this.examId,
      size: 'xl'
    };
    this.webcamModelRef?.close();
    
    this.webcamModelRef = this.modalService.open(this.passportCaptureModal, modalOptions);
  }

  isInIframe() {
    return self != top;
  }

  updateImageUrl(e: any) {
    //debugger;
    this.imageUrl = "/assets/images/defaultuserimage.jpeg";
  }
  countdownNotifyMessage: string = '';
  countdownCurrentTimeMessage: string = '';

  countDownEventHandler($event: any) {
    if ($event.action == "done") {
      if (!this.useQuestionTimer) {
        this.examservice.notifyExamTimeElapsed(true);
      }

      this.countdownNotifyMessage = 'Time is up.';
      return;
    }

    setTimeout(() => this.setCountdownAriaHidden(), 0);

    if ($event.action === 'notify') {
      const minutesLeft = Math.floor($event.left / 60000);
      this.countdownNotifyMessage = `${minutesLeft} ${this.language.minutes} ${this.language.remaining}.`;
      setTimeout(() => {
        this.countdownNotifyMessage = '';
      }, 2000); // Clear after a brief delay
    }

    setTimeout(() => {
      this.countdownCurrentTimeMessage = this.formatRemainingTime(($event.left - 5000) / 1000);
    }, 0);
  }

  private setCountdownAriaHidden(): void {
    const wrapper = this.countdownWrapper?.nativeElement;
    if (wrapper) {
      const span = wrapper.querySelector('span');
      if (span) {
        span.setAttribute('aria-hidden', 'true');
      }
    }
  }

  formatRemainingTime(seconds: number): string {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;

    if (mins > 0 && secs === 0) {
      return `${mins}  ${this.language.minutes} ${this.language.remaining}`;
    }
    if (mins > 0 && secs > 0) {
      return `${mins} ${this.language.minutes} ${this.language.and} ${secs} ${this.language.seconds} ${this.language.remaining}`;
    }
    return `${secs} ${this.language.seconds} ${this.language.remaining}`;
  }

  toggleCalculator() {
    this.calculatorToggleService.toggle();
  }

  toggleExaminationInstructionModal() {
    this.examInstructionToggleService.toggle();
  }
  zoomQuestionIn() {
    this.examservice.triggerQuestionZoom(true);
  }

  zoomQuestionOut() {
    this.examservice.triggerQuestionZoom(false);
  }

  getNotifyIntervals(totalSeconds: number | null): number[] {
    const intervals: number[] = [];
    if (totalSeconds === null) {
      return intervals;
    }

    // Find the highest 10-minute mark below totalSeconds
    const highestTenMinuteMark = Math.floor(totalSeconds / 600) * 600;

    // Add all 10-minute marks from highest down to 600 (10 minutes)
    for (let sec = highestTenMinuteMark; sec >= 600; sec -= 600) {
      intervals.push(sec);
    }

    // Always ensure we get the last 5m and 1m if they're less than totalSeconds
    [300, 60].forEach(s => {
      if (!intervals.includes(s) && s < totalSeconds) {
        intervals.push(s);
      }
    });

    return intervals;
  }

  get shouldShowCountdown(): boolean {
    if (this.useQuestionTimer) {
      return this.timeRemaining !== null && !this.isExamPaused;
    }

    return (
      this.timeRemaining !== null &&
      this.timeRemaining !== this.EXAM_OPEN_DURATION
    );
  }
}
